<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    // console.log(this.$store.state.loginstatus)
    if (this.$store.state.loginstatus === false) window.localStorage.clear()
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      // this.$router.replace('/login');
      localStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))))

    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
  },

}
</script>

<style>
/* *{
  overflow: hidden;
} */
  #app{
    width: 100%;
    height: 100%;
    min-width: 1000px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue